export const theme = {
  colors: {
    brand: {
      primary: {
        default: 'var(--colors-brand-primary)',
        hover: 'var(--colors-brand-primary-hover)',
        active: 'var(--colors-brand-primary-active)',
        disabled: 'var(--colors-brand-primary-disabled)',
        opaque: 'var(--colors-brand-primary-opaque)',
        text: 'var(--colors-brand-primary-text)',
      },
      secondary: {
        default: 'var(--colors-brand-secondary)',
        hover: 'var(--colors-brand-secondary-hover)',
        active: 'var(--colors-brand-secondary-active)',
        disabled: 'var(--colors-brand-secondary-disabled)',
        opaque: 'var(--colors-brand-secondary-opaque)',
        text: 'var(--colors-brand-secondary-text)',
      },
    },
    thumbnail: {
      text: 'var(--colors-thumbnail-text)',
    },
    primary: {
      100: 'var(--colors-primary-100)',
      80: 'var(--colors-primary-80)',
      60: 'var(--colors-primary-60)',
      40: 'var(--colors-primary-40)',
      20: 'var(--colors-primary-20)',
    },
    secondary: {
      100: 'var(--colors-secondary-100)',
      80: 'var(--colors-secondary-80)',
      60: 'var(--colors-secondary-60)',
      40: 'var(--colors-secondary-40)',
    },
    background: {
      100: 'var(--colors-background-100)',
      80: 'var(--colors-background-80)',
      60: 'var(--colors-background-60)',
      40: 'var(--colors-background-40)',
    },
    foreground: {
      100: 'var(--colors-foreground-100)',
      80: 'var(--colors-foreground-80)',
      60: 'var(--colors-foreground-60)',
      40: 'var(--colors-foreground-40)',
    },
    error: {
      100: 'var(--colors-error-100)',
      80: 'var(--colors-error-80)',
      60: 'var(--colors-error-60)',
      40: 'var(--colors-error-40)',
    },
    success: {
      100: 'var(--colors-success-100)',
      80: 'var(--colors-success-80)',
      60: 'var(--colors-success-60)',
      40: 'var(--colors-success-40)',
    },
    warning: {
      100: 'var(--colors-warning-100)',
      80: 'var(--colors-warning-80)',
      60: 'var(--colors-warning-60)',
      40: 'var(--colors-warning-40)',
    },
    base: {
      text: 'var(--colors-text-base)',
      border: 'var(--colors-border-base)',
      muted: 'var(--colors-text-muted)',
    },
    gradients: {
      primary: {
        0: 'var(--colors-gradient-primary-0)',
        100: 'var(--colors-gradient-primary-100)',
      },
      secondary: {
        0: 'var(--colors-gradient-secondary-0)',
        100: 'var(--colors-gradient-secondary-100)',
      },
    },
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    default: '1rem',
    md: '1.125rem',
    lg: '1.25rem',
    xl: '1.5rem',
    '2xl': '1.875rem',
    '3xl': '2.25rem',
    // Legacy support
    large: '1.6rem',
    small: '1.2rem',
    tiny: '1rem',
  },
  spacing: {
    px: '1px',
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    8: '2rem',
    10: '2.5rem',
    12: '3rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    // Legacy support
    default: '1.6rem',
    vertical: '1.6rem 0',
    horizontal: '0 1.6rem',
    large: '2.4rem',
  },
  transition: {
    fast: '100ms ease-in-out',
    default: '150ms ease-in-out',
    slow: '300ms ease-in-out',
  },
  radii: {
    none: '0',
    sm: '0.25rem',
    default: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
    full: '9999px',
    // Legacy support
    small: '0.4rem',
    smallTop: '0.4rem 0.4rem 0 0',
    smallBottom: '0 0 0.4rem 0.4rem',
    tiny: '0.2rem',
  },
  shadows: {
    none: 'none',
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    default:
      '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    // Legacy support
    flat: '0 0.2rem 0.2rem rgba(0, 0, 0, 0.08)',
  },
  // Layout dimensions
  layout: {
    sidebar: 'var(--layout-sidebar-width)',
    header: 'var(--layout-header-height)',
    interactionPanel: 'var(--layout-interaction-panel-width)',
    interactionPanelCollapsed: 'var(--layout-interaction-panel-collapsed)',
  },
  breakpoints: {
    sm: '0px', // down() = maxWidth: 640px
    md: '640px', // down() = maxWidth: 768px
    lg: '768px', // down() = maxWidth: 1024px
    xl: '1024px', // down() = maxWidth: 1280px
    xxl: '1280px', // down() = maxWidth: 1536px
    xxxl: '1536px', // down() = maxWidth: 1920px
    '4xl': '1920px', // Full HD
    '5xl': '2560px', // 2K/QHD
  },
} as const;
